import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const ManageListingsPage = () => {
  return (
    <Container maxWidth="lg">
      <Box py={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Manage Listings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Admin dashboard for managing property listings
        </Typography>
      </Box>
    </Container>
  );
};

export default ManageListingsPage;